import React, { useState, useEffect } from 'react';

export default function GlobalSlowLoader() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleStart = () => setIsVisible(true);
        const handleEnd = () => setIsVisible(false);

        window.addEventListener('api:slow_loading_start', handleStart);
        window.addEventListener('api:slow_loading_end', handleEnd);

        return () => {
            window.removeEventListener('api:slow_loading_start', handleStart);
            window.removeEventListener('api:slow_loading_end', handleEnd);
        };
    }, []);

    if (!isVisible) return null;

    return (
        <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white/80 backdrop-blur-sm transition-all duration-500">
            <div className="relative flex flex-col items-center">
                {/* Logo with blur-to-visible animation */}
                <img 
                    src="/assets/images/logo.png" 
                    alt="Loading..." 
                    className="w-24 h-24 object-contain animate-[blurToVisible_1.5s_ease-in-out_infinite_alternate]"
                />
                <div className="mt-4 flex flex-col items-center">
                    <span className="text-sm font-semibold tracking-wider text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-purple-600 animate-pulse">
                        Chargement des données...
                    </span>
                    <p className="text-xs text-gray-500 mt-1">Merci de patienter</p>
                </div>
            </div>
            
            <style>{`
                @keyframes blurToVisible {
                    0% {
                        filter: blur(8px);
                        opacity: 0.5;
                        transform: scale(0.9);
                    }
                    100% {
                        filter: blur(0px);
                        opacity: 1;
                        transform: scale(1.1);
                    }
                }
            `}</style>
        </div>
    );
}
